import { useQuery } from '@tanstack/react-query';

import { logException } from 'helpers/loggers';

import { onboardingProgressQueryKey } from './progress';
import type { OnboardingProgress } from './progress';
import { progressClient } from './progressClient';
import { useExpireSessionOnUnauthorized } from './useExpireSessionOnUnauthorized';

export const useGetOnboardingProgress = (restaurantId: string | undefined) => {
  const expireSessionOnUnauthorized = useExpireSessionOnUnauthorized();

  return useQuery<OnboardingProgress>({
    queryKey: onboardingProgressQueryKey(restaurantId),
    queryFn: async () => {
      try {
        return await progressClient.get(restaurantId as string);
      } catch (error) {
        logException({
          message: 'Failed to fetch onboarding progress',
          error,
          context: { restaurantId },
          tags: null,
        });
        expireSessionOnUnauthorized(error);
        throw error;
      }
    },
    enabled: !!restaurantId,
    // a step mounting its own observer must not refetch a failed GET, which loops with the loader
    retryOnMount: false,
  });
};
